import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}><path d="M256 217.9L383 345a23.9 23.9 0 0033.9 0c9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17a23.9 23.9 0 0033.9 0l127.1-127z" /></svg>;